import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from 'src/app/shared/service/api.service';
import { CONSTANTS } from 'src/app/constants';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-ranking-sellers',
  templateUrl: './ranking-sellers.component.html',
  styleUrls: ['./ranking-sellers.component.css']
})
export class RankingSellersComponent implements OnInit {
  _filterAccomplish: any = {};
  @Input() set filterAccomplish(value: any) {
    this._filterAccomplish = value;
    this.filterItem(this._filterAccomplish);
  }

  @Output() errorEmitter = new EventEmitter();

  topTooltipExcel: string = 'Download .xlsx';
  dataItem: any = {
    chart: {
      numberPrefix: "R$",
      aligncaptionwithcanvas: "0",
      plottooltext:
        "<b>$dataValue</b>",
      theme: "gammel",
      decimalSeparator: ",",
      thousandSeparator: ".",
      showvalues: "1",
      placevaluesinside: "0"
    },
    data: []
  };
  width = '100%';
  height = '320';
  type = 'bar2d';
  dataFormat = 'json';
  dataSource = this.dataItem;
  loading: boolean = true;
  dateFirst!: any;
  listItem: { label: string, type: number, value: number }[] = [
    { label: "VALOR", type: 0, value: 0},
    { label: "QUANTIDADE VENDAS", type: 1, value: 1},
    { label: "QUANTIDADE PEÇAS", type: 2, value: 2},
  ];
  typeSelected: any = 0;
  orderByQuantity: boolean = false;
  filterStart: any;
  errorApi = false;
  message : string = "";

  constructor(private api: ApiService) { }

  ngOnInit() {
  }

  recoverValues(item: any) {
    this.typeSelected = item;
    this.filterItem(this.filterStart);
  }

  filterItem(item: any) {
    this.errorApi = false;
    this.loading = true;
    if (item.branch != undefined) {
      this.filterStart = item;

      this.rankingSellersMethod(item).subscribe(data => {
        try {
          this.dataItem.data = [];
          let excelInfo = [];
          if (data.dataRow.length != 0) {
            data.dataRow.map((el:any) => {
              if (this.dataItem.data.length < 10) {
                if (this.typeSelected === 0) {
                  // VALOR
                  this.dataItem.chart.numberPrefix = 'R$';
                  excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Código Filiais': item.branch.toString(), 'Nome': el.seller_name.toString(), 'Valor': 'R$' + el.seller_sale_value.toString()});
                  this.dataItem.data.push({
                    'label': el.seller_name === null ? 'Nome não informado' : el.seller_name,
                    'value': el.seller_sale_value
                  });
                } else if (this.typeSelected === 1) {
                  // QUANTIDADE VENDAS
                  this.dataItem.chart.numberPrefix = '';
                  excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Código Filiais': item.branch.toString(), 'Nome': el.seller_name.toString(), 'Quantidade Vendas': el.seller_sale_qty.toString()});
                  this.dataItem.data.push({
                    'label': el.seller_name === null ? 'Nome não informado' : el.seller_name,
                    'value': el.seller_sale_qty || 0
                  });
                } else if (this.typeSelected === 2) {
                  // QUANTIDADE PEÇAS
                  this.dataItem.chart.numberPrefix = '';
                  excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Código Filiais': item.branch.toString(), 'Nome': el.seller_name.toString(), 'Quantidade Peças': el.seller_sale_item_qty.toString()});
                  this.dataItem.data.push({
                    'label': el.seller_name === null ? 'Nome não informado' : el.seller_name,
                    'value': el.seller_sale_item_qty || 0
                  });
                }
              }
            })
            excelInfo.unshift({});
            localStorage.setItem('ranking-sellers', JSON.stringify(excelInfo));
            this.errorApi = false;
          } else {
            this.message = CONSTANTS.MESSAGES.DATA_NULL_RANKING_SELLERS;
            this.formatErrorMensagem(CONSTANTS.MESSAGES.DATA_NULL_RANKING_SELLERS);
            this.errorApi = true;
          }
          this.loading = false;
        } catch (error: unknown){
          this.loading = false;
          if (error instanceof Error)
            this.formatErrorMensagem(error.message);
        }
      }, error => {
        this.loading = false;
        this.errorApi = true;
        this.message = CONSTANTS.MESSAGES.DATA_ERRO_RANKING_SELLERS;
        this.formatErrorMensagem(error.message);
      });
    }
  }

  downloadExcel() {
    const EXCEL_TYPE =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';

    let dataRankingSellers = [];
    let objectRankingSellers = localStorage.getItem('ranking-sellers');

    objectRankingSellers != null
      ? (dataRankingSellers = JSON.parse(objectRankingSellers))
      : (dataRankingSellers = []);
    const worksheetRankingSellers= XLSX.utils.json_to_sheet(dataRankingSellers);

    const workbook = {
      Sheets: {
        'ranking-vendedores': worksheetRankingSellers,
      },
      SheetNames: [
        'ranking-vendedores',
      ],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'buffer',
    });
    const data: Blob = new Blob([excelBuffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, 'minhas-operacoes-ranking-vendedores' + EXCEL_EXTENSION);
  }

  rankingSellersMethod(item: any) {
    return this.api.postSellers(item.dataMin, item.dataMax, item.branch, item.sellers);
  }

  formatErrorMensagem(item: any) {
    let dataError = new Date();
    let errorMensagem = "Arquivo: ranking-sellers \r\n" + "Data: " + dataError + "\r\n" + "Mensagem: " + item + "\r\n" + "===============================================" + "\r\n";
    this.errorEmitter.emit(errorMensagem);
  }

}
